import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';
import { CalendarPage } from '../calendar/calendar';
import { VideoPage } from '../video/video';
import { DirectionsPage } from '../directions/directions';
import { SecurityhomePage } from '../securityhome/securityhome';

@Component({
  selector: 'page-visitors-prereg',
  templateUrl: 'visitors-prereg.html'
})
export class VisitorsPreRegPage {
  private vistor_prereg : FormGroup;
  loading: Loading;

  items:any;
  disclaimer = false;
 

  imgPreview = '../../assets/imgs/upload.jpeg';
  regData = { avatar:'', name: '', surname: '', id_passport: '', email: '',mnumber: '', carreg:'', carmodel:'', company:'' };
  title = "Mr";
  name = "";
  surname = "";
  id_type = "ID";
  id_passport = "";
  mnumber = "";
  email = "";
  carreg = "";
  carmodel = "";
  carmake = "";
  company = "";

  
  accessCode = "";
  authtoken = "";

    

  validation_messages = {
    'title': [
      { type: 'required', message: '*Please choose title.' },
    ],
    'name': [
      { type: 'required', message: '*Please enter a name.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'surname': [
      { type: 'required', message: '*Please enter a surname.' },
    ],
    'id_passport': [
      { type: 'required', message: '*Please enter an id number.' },
      { type: 'pattern', message: '*Please enter a valid id number.' },
    ],
    'email': [
      { type: 'required', message: '*Please enter an email.' },
      { type: 'pattern', message: '*Please enter a valid email.' },
    ],
    'mnumber': [
      { type: 'required', message: '*Please enter mobile number.' },
      { type: 'pattern', message: '*Please enter 9 digit mobile number.' }
    ],/*
    'mnumber': [
      //{ type: 'required', message: '*Please enter mobile number.' },
      //{ type: 'pattern', message: '*Please enter 9 digit mobile number.' }
    ],
    'carreg': [
      { type: 'required', message: '*Please enter a car registration.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'carmodel': [
      { type: 'required', message: '*Please enter a car model.' },
    ],
    'company': [
      { type: 'required', message: '*Please enter a company.' },
    ],*/
      
  }


  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,   
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      private storage: Storage,
      public loadingCtrl: LoadingController ,
      public global: GlobalProvider
    ) {
    
    this.vistor_prereg = this.formBuilder.group({
      title: [null],//['', Validators.required],
      name: ['', Validators.required],//, Validators.pattern('[a-zA-Z ]*')],
      surname: ['', Validators.required],
      /*id_passport: ['',Validators.compose([
                        Validators.required,
                        Validators.pattern('^[a-zA-Z0-9_.+-]+$')
                      ])
                    ],
      mnumber: [null],//['', Validators.pattern('[0-9]{9}')],*/
      id_passport: ['',Validators.compose([
              Validators.required,
              Validators.pattern('^[0-9]{13}')
            ])
          ],
      //mnumber: ['', Validators.pattern('[0-9]{9}')],
      mnumber: ['',Validators.compose([
                  Validators.required,
                  Validators.pattern('[0-9]{9}')
                ])
              ],
      email: ['',Validators.compose([
                  Validators.required,
                  Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
                ])],
      carreg: [null],//['', Validators.required],//'',//['', Validators.required],
      carmodel: [null],//['', Validators.required],//'',//['', Validators.required],
      carmake: [null],
      /*company: ['', Validators.required]//['', Validators.required]*/
    });

    this.storage.get('accesscode').then((val) => {
      console.log('acc = '+val);
      this.accessCode = val;
      this.storage.get('Authorization').then((val1) => {
        console.log('acc = '+this.accessCode);
        this.authtoken = val1;
      });
      
    });
  }


  public CValue:String;
  onChange(CValue) {
    const id_passportValue = this.vistor_prereg.get('id_passport');
    if(CValue == 'ID'){
      id_passportValue.setValidators([Validators.pattern('^[0-9]{13}')]);
    }else if(CValue == 'PASSPORT'){
      id_passportValue.setValidators([Validators.pattern('^[a-zA-Z0-9_.+-]+$')]);
    }
    id_passportValue.updateValueAndValidity();
  }

  formMobileChanged(){
    const emailCtrl = this.vistor_prereg.get('email');
    const phoneCtrl = this.vistor_prereg.get('mnumber');
    this.vistor_prereg.get('mnumber').valueChanges.subscribe(
      (mobileStr: string) => {
        console.log(mobileStr);
        if(mobileStr == ''){
          emailCtrl.setValidators([Validators.required]);
        }else{
          emailCtrl.clearValidators();
        }
        emailCtrl.updateValueAndValidity();

    });

  }

  formEmailChanged(){
    const phoneCtrl = this.vistor_prereg.get('mnumber');

    this.vistor_prereg.get('email').valueChanges.subscribe(
      (emailStr: string) => {
        if(emailStr == ''){
          phoneCtrl.setValidators([Validators.required]);
        }else{
          phoneCtrl.clearValidators();
        }
        phoneCtrl.updateValueAndValidity();

    });

  }

  goback(){
    this.navCtrl.pop();
  }

  showDisclaimer(){
    this.disclaimer = true;
  }
  hideDisclaimer(){
    this.disclaimer = false;
  }

  regForm(){
    //(<HTMLInputElement> document.getElementById('checkIn')).disabled=true;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    let phones = [];
    if(this.mnumber == ""){

    }else{
      phones.push({'number':this.mnumber});
    }
    let postData = JSON.stringify({
        "preregisterVisitorDTO": {
          "captureType": "visitor",
          "cars": [
            {
              "make": this.carmake,
              "model": this.carmodel,
              "registration": this.carreg
            }
          ],
          "email": this.email,
          "idNumber": this.id_passport,
          "identityType": this.id_type,
          "licenseNumber": this.id_passport,
          "name": this.name,
          "passport": this.id_passport,
          "phones": phones,
          "surname": this.surname,
          "title": this.title,
          "verificationCode": ""
        }
    }); 

    console.log(postData);
    
    this.http.post(this.global.baseUrl+"api/admin/pre-register", postData, httpOptions)
      .subscribe((data:any) => {
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 3000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            this.hideDisclaimer();
            //(<HTMLInputElement> document.getElementById('checkIn')).disabled=false;
          }else{
            console.log(data.visitorDTO);
            let toast = this.toastCtrl.create({
              message: 'Visitor created successfully.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('checkIn')).disabled=false;
            
            this.navCtrl.push(SecurityhomePage);
          }
        }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 3000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          this.hideDisclaimer();
          //(<HTMLInputElement> document.getElementById('checkIn')).disabled=false;
          
      });
      
  }
}



// WEBPACK FOOTER //
// ./src/pages/visitors-prereg/visitors-prereg.ts